<template>
    <div>
        <div class="title">
            <div @click="dianjishow(1)" :class="show == 1 ? 'active' : ''">
                物流快递
            </div>
            <div @click="dianjishow(2)" :class="show == 2 ? 'active' : ''">
                商家配送
            </div>
            <div @click="dianjishow(3)" :class="show == 3 ? 'active' : ''">
                到点/自提
            </div>
            <div @click="dianjishow(4)" :class="show == 4 ? 'active' : ''">
                自动发货
            </div>
        </div>

        <div class="add">
            <el-button size="small" type="primary" @click="addClick()">+ 新建模板</el-button>
        </div>

        <div class="table-wrap">
            <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
                <el-table-column label="发货模板" width="1000">
                    <template slot-scope="scope">
                        <div>{{ scope.row }}</div>
                    </template>
                </el-table-column>

                <el-table-column label="首件">
                    <template slot-scope="scope">
                        <div></div>
                    </template>
                </el-table-column>

                <el-table-column label="运费(元)">
                    <template slot-scope="scope">
                        <div></div>
                    </template>
                </el-table-column>

                <el-table-column label="续件">
                    <template slot-scope="scope">
                        <div></div>
                    </template>
                </el-table-column>

                <el-table-column label="续费(元)">
                    <template slot-scope="scope">
                        <div></div>
                    </template>
                </el-table-column>


                <el-table-column fixed="right" label="操作" width="160">
                    <template slot-scope="scope" v-if="!scope.row.is_top_row">
                        <el-button @click="editData(scope.row)" type="primary" size="small">编辑</el-button>
                        <el-button @click="addData(scope.row)" type="danger" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-dialog :title="title" :visible.sync="dialogVisibleadd" width="30%" :before-close="handleClose">
            <div class="tjfxdq">
                <div> <span> 模板名称:</span> <el-input v-model="mbname" placeholder="请输入模板名称"></el-input></div>
            </div>
            <div>
                <div>
                    <span> 计价方式:</span>
                    <el-radio v-model="radio" label="1">按件数</el-radio>
                    <el-radio v-model="radio" label="2">按重量</el-radio>
                </div>
            </div>

            <el-table style="width: 100%">
                <el-table-column  label="可配送区域" width="180">
                </el-table-column>
                <el-table-column  label="运费(元)" width="180">
                </el-table-column>
                <el-table-column  label="续件">
                </el-table-column>
                <el-table-column  label="续费(元)">
                </el-table-column>
            </el-table>
            <div class="anniu">
                <el-button @click="dialogVisibleadd = false">取 消</el-button>
                <el-button type="primary" @click="queding()">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>
  
<script>
import pei from '@/api/pei.js';
export default {
    name: 'pei',
    data() {
        return {
            radio: 1,
            show: 1,
            title: "",
            dialogVisibleadd: false,
            mbname: "",
            /*是否加载完成*/
            loading: true,
            /*列表数据*/
            tableData: [],
            /*一页多少条*/
            pageSize: 10,
            /*一共多少条数据*/
            totalDataNumber: 0,
            /*当前是第几页*/
            curPage: 1,
        };
    },
    created() {
        /*获取列表*/
        this.getData();
    },
    methods: {
        // 编辑按钮
        editData() {
            console.log("点击了编辑按钮");
        },
        // 删除按钮
        addData() {
            console.log("点击了删除按钮");
        },
        // 弹窗关闭
        handleClose() {
            this.dialogVisibleadd = false;
        },
        // 弹框确定
        queding() {
            console.log("点击了确定");
            console.log(this.mbname);
        },
        // 添加模板
        addClick() {
            this.dialogVisibleadd = true;
            this.title = "创建模板"
        },
        // 点击分类方法
        dianjishow(data) {
            console.log(data);
            this.show = data;
        },
        /*选择第几页*/
        handleCurrentChange(val) {
            let self = this;
            self.curPage = val;
            self.getData();
        },

        /*每页多少条*/
        handleSizeChange(val) {
            this.curPage = 1;
            this.pageSize = val;
            this.getData();
        },

        /*获取列表*/
        getData() {
            let self = this;
            let Params = {

            }
            self.loading = true;
            pei.kpsindex(Params, true)
                .then(res => {
                    console.log(res.data.list, "resres");
                    self.loading = false;
                    console.log(self.loading);
                    self.tableData = Object.values(res.data.list);
                    this.totalDataNumber = res.data.list.total;
                })
                .catch(error => { });
        },
    },
    filters: {
        // 过滤器
        formatDate(create_time1) {
            let date = new Date(create_time1 * 1000);
            //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? ('0' + MM) : MM; //月补0
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d; //天补0
            let h = date.getHours();
            h = h < 10 ? ('0' + h) : h; //小时补0
            let m = date.getMinutes();
            m = m < 10 ? ('0' + m) : m; //分钟补0
            let s = date.getSeconds();
            s = s < 10 ? ('0' + s) : s; //秒补0
            // return y + '-' + MM + '-' + d; //年月日
            return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s; //年月日时分秒

        },
    },
};
</script>
  
<style lang="scss">
.title {
    width: 100%;
    border-bottom: 1px solid #E6E9EE;
    display: flex;
}

.title div {
    width: 135px;
    height: 60px;
    line-height: 60px;
    text-align: center;
}

.active {
    border-bottom: 2px solid #7438D5;
    color: #7438D5;
}

.add {
    margin: 20px 0;
}

.tjfxdq {
    margin-bottom: 15px;
}

.tjfxdq div {
    display: flex;
    margin-top: 20px;
}

.tjfxdq div span {
    width: 15%;
    margin-top: 25px;
}

.anniu {
    display: flex;
    justify-content: flex-end;
}
</style>


// WEBPACK FOOTER //
// src/views/setting/region/kpsindex.vue